/* ==========================================================================
   dtc-product.js. Product page enhancements.

   EVERYTHING HERE IS PROGRESSIVE. With JS disabled the page still works:
     - the gallery is a native scroll-snap track and the thumbs are anchors
     - the <noscript> variant <select> posts name="id"
     - the form does a normal POST to /cart/add
   This file only upgrades that baseline.

   Registered through the shared lifecycle so the theme editor can mount and
   unmount the section cleanly (every listener/observer is released).
   ========================================================================== */
(function () {
  'use strict';
  if (!window.DTC) return;

  DTC.register('product', { init: function (root) {
    var offs = [];
    function on(el, type, fn, opts) { if (el) offs.push(DTC.on(el, type, fn, opts)); }

    /* ------------------------------------------------------------------ *
     * Data
     * ------------------------------------------------------------------ */
    var dataEl = root.querySelector('[data-dtc-variants]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; }
      catch (err) { console.error('[DTC] variant JSON failed to parse', err); }
    }

    /* FAIL OPEN, and read the next paragraph before removing this flag.

       An empty `variants` is indistinguishable from "every variant is sold
       out" to the code below. `variants.some(...)` over [] is false for every
       option, so refreshAvailability strikes out every size; findVariant
       returns undefined, so renderButton disables the button and prints
       "Unavailable". One truncated response, one carrier proxy transcoding
       the page, or one content blocker stripping inline JSON is therefore
       enough to kill a product page for a shirt Shopify says is fully in
       stock, and only for that one visitor.

       The server already rendered the correct state into the markup. When we
       have no data to improve on it, leave it alone. */
    var hasVariantData = variants.length > 0;

    var form = root.querySelector('[data-dtc-product-form]');
    var idInput = root.querySelector('[data-dtc-variant-id]');
    var priceEl = root.querySelector('[data-dtc-price]');
    var compareEl = root.querySelector('[data-dtc-compare]');
    var saveEl = root.querySelector('[data-dtc-save]');
    var atc = root.querySelector('[data-dtc-atc]');
    var atcLabel = root.querySelector('[data-dtc-atc-label]');
    var barPrice = root.querySelector('[data-dtc-bar-price]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-dtc-option]'));
    var optionCount = Number(root.getAttribute('data-option-count')) || 0;

    var strings = {
      add: (atc && atc.getAttribute('data-label-add')) || 'Add to cart',
      soldOut: (atc && atc.getAttribute('data-label-soldout')) || 'Sold out',
      unavailable: (atc && atc.getAttribute('data-label-unavailable')) || 'Unavailable'
    };

    /* ------------------------------------------------------------------ *
     * GALLERY, thumbs, active state, counter, optional zoom
     * ------------------------------------------------------------------ */
    var gal = root.querySelector('[data-dtc-gallery]');
    var track = root.querySelector('[data-dtc-gal-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-dtc-slide]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dtc-thumb]'));
    var counter = root.querySelector('[data-dtc-gal-counter]');
    var galIO = null;

    function goToSlide(i, smooth) {
      if (!track || !slides[i]) return;
      var behavior = (smooth === false || DTC.reducedMotion) ? 'auto' : 'smooth';
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: behavior });
    }

    function markActive(i) {
      thumbs.forEach(function (t, n) {
        if (n === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(slides.length);
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function (e) {
        e.preventDefault();
        goToSlide(i);
        markActive(i);
      });
    });

    if (track && slides.length > 1 && 'IntersectionObserver' in window) {
      galIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            markActive(slides.indexOf(entry.target));
          }
        });
      }, { root: track, threshold: [0.61] });
      slides.forEach(function (s) { galIO.observe(s); });
    }
    if (slides.length) markActive(0);

    /* Click-to-zoom, fine pointers only. */
    if (gal && gal.classList.contains('dtc-gal--zoom') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      slides.forEach(function (slide) {
        var img = slide.querySelector('.dtc-gal__img');
        if (!img) return;
        on(img, 'click', function (e) {
          var zoomed = img.classList.toggle('is-zoomed');
          if (zoomed) {
            var r = img.getBoundingClientRect();
            img.style.transformOrigin =
              (((e.clientX - r.left) / r.width) * 100).toFixed(2) + '% ' +
              (((e.clientY - r.top) / r.height) * 100).toFixed(2) + '%';
          } else {
            img.style.transformOrigin = '';
          }
        });
      });
    }

    /* ------------------------------------------------------------------ *
     * VARIANTS
     * ------------------------------------------------------------------ */
    function selectedValues() {
      var out = [];
      for (var i = 0; i < optionCount; i++) {
        var checked = root.querySelector('[data-dtc-option][data-option-index="' + i + '"]:checked');
        out.push(checked ? checked.value : null);
      }
      return out;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var hit = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    /* A value is offered if some variant exists that matches every already
       chosen value to its LEFT. Purchasability is shown by the struck style. */
    function refreshAvailability(values) {
      if (!hasVariantData) return;
      radios.forEach(function (input) {
        var idx = Number(input.getAttribute('data-option-index'));
        var label = input.nextElementSibling;
        if (!label) return;
        var purchasable = variants.some(function (v) {
          if (!v.available) return false;
          if (v.options[idx] !== input.value) return false;
          for (var j = 0; j < idx; j++) {
            if (values[j] && v.options[j] !== values[j]) return false;
          }
          return true;
        });
        label.classList.toggle('is-unavailable', !purchasable);
      });
    }

    function setText(el, text) { if (el) el.textContent = text; }

    function renderPrice(variant) {
      if (!variant) return;
      setText(priceEl, DTC.money(variant.price));
      if (barPrice) barPrice.textContent = DTC.money(variant.price);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.textContent = onSale ? DTC.money(variant.compare_at_price) : '';
        compareEl.hidden = !onSale;
      }
      if (saveEl) {
        if (onSale) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          saveEl.textContent = 'SAVE ' + pct + '%';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function renderButton(variant) {
      if (!atc) return;
      if (!hasVariantData) return;
      if (!variant) {
        atc.disabled = true;
        setText(atcLabel, strings.unavailable);
      } else if (!variant.available) {
        atc.disabled = true;
        setText(atcLabel, strings.soldOut);
      } else {
        atc.disabled = false;
        setText(atcLabel, strings.add);
      }
    }

    function syncGalleryTo(variant) {
      if (!variant || !variant.featured_image || !slides.length) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-image-id') === String(variant.featured_image.id)) {
          goToSlide(i);
          markActive(i);
          return;
        }
      }
    }

    function updateUrl(variant) {
      if (!variant || !window.history || !history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    function onOptionChange() {
      var values = selectedValues();
      refreshAvailability(values);
      var variant = findVariant(values);
      if (idInput) idInput.value = variant ? variant.id : '';
      renderPrice(variant);
      renderButton(variant);
      syncGalleryTo(variant);
      updateUrl(variant);
    }

    radios.forEach(function (input) {
      on(input, 'change', function () {
        var head = root.querySelector('[data-dtc-option-value="' + input.getAttribute('data-option-index') + '"]');
        if (head) head.textContent = input.value;
        onOptionChange();
      });
    });

    if (radios.length) refreshAvailability(selectedValues());

    /* ------------------------------------------------------------------ *
     * REVALIDATE AGAINST LIVE DATA
     *
     * [data-dtc-variants] is baked into the document at render time, and
     * storefront HTML ships with no Cache-Control, no Expires and no
     * Last-Modified. A back/forward navigation or a restored tab may
     * therefore replay a stored body with no conditional request, so the
     * availability we parsed can be arbitrarily old. One request settles it.
     *
     * Silent on failure: if the fetch does not land, the server-rendered
     * state stands, which is the same fail-open rule as the parse above.
     * ------------------------------------------------------------------ */
    function revalidateAvailability() {
      if (!window.fetch || !hasVariantData) return;
      fetch(window.location.pathname.split('?')[0] + '.js', { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (live) {
          if (!live || !live.variants || !live.variants.length) return;
          var byId = {};
          live.variants.forEach(function (lv) { byId[String(lv.id)] = lv; });

          var changed = false;
          variants.forEach(function (v) {
            var fresh = byId[String(v.id)];
            if (fresh && fresh.available !== v.available) {
              v.available = fresh.available;
              changed = true;
            }
          });
          if (!changed) return;

          var values = selectedValues();
          if (radios.length) refreshAvailability(values);
          renderButton(findVariant(values));
        })
        .catch(function () {});
    }

    revalidateAvailability();
    on(window, 'pageshow', function (e) { if (e.persisted) revalidateAvailability(); });

    /* ------------------------------------------------------------------ *
     * QUANTITY
     * ------------------------------------------------------------------ */
    var qtyInput = root.querySelector('[data-dtc-qty]');
    Array.prototype.slice.call(root.querySelectorAll('[data-dtc-qty-step]')).forEach(function (btn) {
      on(btn, 'click', function () {
        if (!qtyInput) return;
        var step = Number(btn.getAttribute('data-dtc-qty-step')) || 1;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    on(qtyInput, 'change', function () {
      var n = parseInt(qtyInput.value, 10);
      if (!n || n < 1) qtyInput.value = 1;
    });

    /* ------------------------------------------------------------------ *
     * ADD TO CART, intercept the native POST, fall back to it on failure.
     * ------------------------------------------------------------------ */
    on(form, 'submit', function (e) {
      if (!idInput || !idInput.value || !atc || atc.disabled) return;   // let the browser handle it
      e.preventDefault();
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var title = form.getAttribute('data-product-title') || '';
      atc.disabled = true;
      DTC.addToCart(idInput.value, qty, title)
        .catch(function () { /* toast already shown by DTC.addToCart */ })
        .then(function () { atc.disabled = false; });
    });

    /* ------------------------------------------------------------------ *
     * SHARE, native sheet where available, clipboard everywhere else.
     * ------------------------------------------------------------------ */
    var share = root.querySelector('[data-dtc-share]');
    if (share) {
      share.classList.add('is-ready');           // JS-only control: reveal it
      on(share, 'click', function () {
        var url = share.getAttribute('data-url') || window.location.href;
        var title = share.getAttribute('data-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            DTC.toast(share.getAttribute('data-copied') || 'Link copied');
          }).catch(function () {});
        }
      });
    }

    /* ------------------------------------------------------------------ *
     * STICKY MOBILE BUY BAR, appears once the real button scrolls away.
     * ------------------------------------------------------------------ */
    var bar = root.querySelector('[data-dtc-buybar]');
    var barIO = null;
    if (bar && atc && 'IntersectionObserver' in window) {
      barIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      barIO.observe(atc);
    }

    /* ------------------------------------------------------------------ *
     * SIZE CHART UNITS, inches <-> centimetres.
     *
     * Both sets of figures are already in the markup; this only flips which
     * ones are hidden. The control itself ships hidden and is revealed here,
     * so a visitor without JS never sees a button that cannot work, they get
     * the complete table in inches instead.
     * ------------------------------------------------------------------ */
    root.querySelectorAll('[data-dtc-sizechart]').forEach(function (chart) {
      var units = chart.querySelector('[data-sizechart-units]');
      var buttons = chart.querySelectorAll('[data-sizechart-unit]');
      if (!units || !buttons.length) return;

      units.hidden = false;

      function show(unit) {
        chart.querySelectorAll('.dtc-sizechart__u').forEach(function (cell) {
          cell.hidden = !cell.classList.contains('dtc-sizechart__u--' + unit);
        });
        buttons.forEach(function (b) {
          var active = b.getAttribute('data-sizechart-unit') === unit;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      buttons.forEach(function (b) {
        on(b, 'click', function () { show(b.getAttribute('data-sizechart-unit')); });
      });
    });

    /* ------------------------------------------------------------------ *
     * Cleanup
     * ------------------------------------------------------------------ */
    return function cleanup() {
      offs.forEach(function (off) { off(); });
      offs.length = 0;
      if (galIO) galIO.disconnect();
      if (barIO) barIO.disconnect();
    };
  } });
}());
